// packages import
import { Autocomplete, TextField } from '@mui/material'
import { FC, useContext } from 'react'

// others
import { BillStatus } from '../../../../../generated'
import { PreBillsContext } from '../../../../context/PreBillsContext'
import { formatStatus } from '../../../../utils/billing'
import { PRE_BILL_STATUSES } from '../../../../constants'

interface StatusOption {
  value: BillStatus
  label: string
}

const preBillStatuses = [...PRE_BILL_STATUSES, BillStatus.Void]
const statusOptions: StatusOption[] = preBillStatuses.map(status => ({
  value: status,
  label: formatStatus(status)
}))

const StatusFilter: FC = () => {
  const { filters, setFilters } = useContext(PreBillsContext)

  const selectedStatus = statusOptions.find(status => status.value === filters.status) || null

  const handleStatusChange = (value: StatusOption | null) => {
    setFilters({ status: value?.value })
  }

  return (
    <Autocomplete
      sx={{ minWidth: 140 }}
      options={statusOptions}
      value={selectedStatus}
      onChange={(_, value) => handleStatusChange(value)}
      getOptionLabel={option => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={params => <TextField {...params} label="Status" />}
    />
  )
}

export default StatusFilter
